__turbopack_context__.v({
  "container": "ButtonLocationMobile-module__5lLKnq__container",
  "fadeInItems": "ButtonLocationMobile-module__5lLKnq__fadeInItems",
  "spacing--lg": "ButtonLocationMobile-module__5lLKnq__spacing--lg",
  "spacing--md": "ButtonLocationMobile-module__5lLKnq__spacing--md",
  "spacing--sm": "ButtonLocationMobile-module__5lLKnq__spacing--sm",
  "spacing--xl": "ButtonLocationMobile-module__5lLKnq__spacing--xl",
  "spacing--xs": "ButtonLocationMobile-module__5lLKnq__spacing--xs",
  "spacing--xxl": "ButtonLocationMobile-module__5lLKnq__spacing--xxl",
  "spacing--xxs": "ButtonLocationMobile-module__5lLKnq__spacing--xxs",
  "spacing--xxxl": "ButtonLocationMobile-module__5lLKnq__spacing--xxxl",
  "spacing--xxxs": "ButtonLocationMobile-module__5lLKnq__spacing--xxxs",
});
